import { useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const displayTestimonials = testimonials.slice(0, 6);

  const next = () => {
    setCurrentIndex((prev) => (prev + 1) % displayTestimonials.length);
  };

  const prev = () => {
    setCurrentIndex((prev) => (prev - 1 + displayTestimonials.length) % displayTestimonials.length);
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            他们说
          </h2>
          <p className="text-sm text-foreground-500">
            来自17c一起社区成员的真实分享
          </p>
        </div>

        <div className="hidden md:grid md:grid-cols-3 gap-5">
          {displayTestimonials.slice(0, 6).map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-background-50 rounded-lg p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-2 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed mb-4 line-clamp-4">
                &ldquo;{testimonial.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-9 h-9 rounded-full object-cover"
                />
                <div>
                  <p className="text-xs font-label font-medium text-foreground-900">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-foreground-400">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="md:hidden relative">
          <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
            <div className="flex items-center gap-2 mb-3">
              {[...Array(displayTestimonials[currentIndex].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
              ))}
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              &ldquo;{displayTestimonials[currentIndex].content}&rdquo;
            </p>
            <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
              <img
                src={displayTestimonials[currentIndex].avatar}
                alt={displayTestimonials[currentIndex].name}
                className="w-9 h-9 rounded-full object-cover"
              />
              <div>
                <p className="text-xs font-label font-medium text-foreground-900">
                  {displayTestimonials[currentIndex].name}
                </p>
                <p className="text-xs text-foreground-400">{displayTestimonials[currentIndex].role}</p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-4 mt-4">
            <button
              onClick={prev}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 border border-background-200/70 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <span className="text-xs text-foreground-400">
              {currentIndex + 1} / {displayTestimonials.length}
            </span>
            <button
              onClick={next}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 border border-background-200/70 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}